import { put, select } from 'redux-saga/effects';

import { navigate } from '@/domain/router/redux/reduxActions';
import * as DocumentActions from '@/domain/documents/documentsActions';
import { isMobile } from '@/lib/systemHelpers/browserHelpers';

import { PostAction } from '@/domain/approvals/navigation/decideNavigation';
import { WorkspaceBackLink, workspaceBackLinkSelector } from '@/domain/approvals/navigation/selectors';

export function* applyPostActionNavigation(postAction: PostAction): Generator<unknown, void, unknown> {
  if (postAction === 'stay') return;

  // Mobile no-op: `@/pages/mobile/approvals/Approvals.jsx` owns its own
  // doc-advance flow via the `onSuccess` callback on the dialogs. Saga-level
  // navigation (URL push or `nextDocumentAction`) would race the mobile
  // page's own logic and pull the user out of the mobile UI.
  if (isMobile) return;

  if (postAction === 'redirectToBackLink') {
    const path = (yield select(workspaceBackLinkSelector)) as WorkspaceBackLink | null;
    if (path) {
      yield put(navigate.push(path));
    }
    return;
  }

  if (postAction === 'nextDoc') {
    yield put({ type: DocumentActions.nextDocumentAction.type, payload: 1 });
  }
}
